<template>
  <header class="header">
    <div class="header-content">
      <div class="header-logo">
        <img :src="headerLogo" alt="" @click="redirectPage('/home')">
      </div>
      <ul>
        <template v-if="showHeaderMenu">
          <li v-for="(item, index) in defaultMenu" :key="index" :data-active="checkMenuActive(item.path)">
            <span @click="redirectPage(item.path)">{{ item.name }}</span>
          </li>
        </template>
      </ul>
      <div class="header-right">
        <el-button type="primary" plain @click="redirectPage('/login')">注册 | 登录</el-button>
      </div>
      <el-link v-if="$i18n.locale==='en'" type="primary" plain @click="changeLanguage('zh')">中文</el-link>
      <el-link v-else type="primary" plain @click="changeLanguage('en')">英文</el-link>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import { Badge } from 'element-ui';
import Logo from '@/assets/images/logo.png';
import defaultAvatar from '@/assets/images/avatar.svg';
export default {
  name: "",
  components: {
    [Badge.name]: Badge
  },
  data() {
    return {
      headerLogo: Logo,
      defaultAvatar
    };
  },
  computed: {
    // 用户名信息
    ...mapGetters({
      userInfo: 'user/userInfo',
      token: 'user/token',
      lang: 'user/lang'
    }),
    // 是否显示头部菜单
    showHeaderMenu() {
      // return !this.$route.path.includes('login') && !this.$route.path.includes('register');
      return true;
    },
    defaultMenu() {
      return [
        {
          name: this.$t('home.index'),
          path: "/home"
        },
        {
          name: this.$t('home.positions'),
          path: "/positions"
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang // 设置给本地的i18n插件
      this.$store.dispatch('user/setLang', lang)
      this.$message.success('切换多语言成功')
    },
    // 退出登录
    async logout() {
      try {
        // 如果退出成功
        await this.$store.dispatch('user/userLogout');
        // 回到首页
        this.$router.push('/home');
      } catch (error) {
        console.log(error)
      }
    },
    errorHandler() {
      console.log('error')
    },
    checkMenuActive(path) {
      return this.$route.path.indexOf(path) === 0;
    },
    redirectPage(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style scoped lang="less">
.header{
  width: 100%;
  min-width: 1200px;
  height: 70px;
  background-color: var(--background-color-white);
  display: flex;

  .header-content {
    margin: 0 auto;
    width: 1200px;
    height: 100%;
    display: flex;
    align-items: center;
    .header-logo {
      width: 145px;
      height: 40px;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
    & > ul {
      display: flex;
      align-items: center;
      flex: 1;
      li {
        font-size: 1rem;
        color: var(--primary-text-color);
        margin: 0 20px;
        cursor: pointer;
        &:hover, &[data-active="true"], &:focus {
          color: var(--primary-color)
        }
      }
    }
    .header-search {
      flex: 1;
    }
  }
}
</style>
<style lang="less">
.el-popover.pop-menu {
  padding: 0;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .pop-menu-avatar {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    p {
      font-size: 1rem;
      color: var(--primary-text-color);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  label {
    width: 100%;
    text-align: center;
    padding: 10px 0;
    border-top: 1px solid var(--regular-border-color);
    cursor: pointer;
    &:hover {
      border-color: var(--primary-color);
      background-color: var(--primary-color);
      color: var(--white-text);
    }
  }
}
</style>
